import { connectNetwork } from 'lib/NetworkProvider'
import View from 'lib/View'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { TOOLBAR_ACTIONS } from '../actions/toolbar'
import { Contract } from '../components'

class SingleContract extends Component {
    constructor(props) {
        super(props)
        let { contract } = this.props.match.params

        this.state = {
            contract,
        }
    }

    componentDidUpdate() {}

    componentDidMount() {}

    render() {
        let { contract } = this.state
        // console.log('Loading contract', contract)
        return (
            <View column fullw fullh>
                <Contract forcedOpen={true} showDetails={true} contractId={contract} type="full" />
            </View>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toolbarRequest: (result) => TOOLBAR_ACTIONS.request(result, dispatch),
        toolbarResult: (result) => TOOLBAR_ACTIONS.result(result, dispatch),
        toolbarError: (result) => TOOLBAR_ACTIONS.error(result, dispatch),
    }
}

const mapStateToProps = (state) => {
    return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(connectNetwork(SingleContract)))